import { api } from '@src/api/api'
import moment from 'moment/moment'

type loginResponse = {
  accessToken: string,
  expiresIn: number,
  tokenType: string,
}

export const authApi = {
  login(phone: string, password: string) {
    return api.post<loginResponse>('/v1/auth/login', { phone, password })
  },
  register(phone: string, password: string, isPromotionalGames: boolean, code: string, isLoyalty: boolean, isProcessingPersonalData: boolean) {
    return api.post<loginResponse>('/v1/auth/register', {
      phone, password, isPromotionalGames, code, isLoyalty, isProcessingPersonalData,
    })
  },
  logout() {
    return api.del('/v1/auth/logout')
  },
  sendRegCode(phone: string, password: string) {
    return api.post('/v1/auth/send-sms-code-register', { phone, password })
  },
  recallPassword(phone: string) {
    return api.post<string>('/v1/auth/send-sms-code-forgot-password', { phone })
  },
  confirmRecallPasswordRegCode(code: string, phone: string) {
    return api.get('/v1/auth/check-sms-code-forgot-password', { code, phone })
  },
  recoveryPassword(password: string, phone: string, code: string) {
    return api.post('/v1/auth/forgot-password', { password, phone, code })
  },
  // newRegister
  registerCard(cardNumber:string) {
    return api.post('/v1/auth/activate-by-card', { card_number: cardNumber.length === 19 ? cardNumber.substr(12) : cardNumber })
  },
  sendRegCodeCard(phone: string) {
    return api.post('/v1/auth/check-phone-send-sms', { phone })
  },
  confirmRegCode(code: string, phone?: string | null, cardNumber?: string) {
    return api.post('/v1/auth/validate-sms-code', { code, phone, card_number: cardNumber?.length === 19 ? cardNumber.substr(12) : cardNumber })
  },
  finalRegistration(
    code: string,
    password: string,
    isProcessingPersonalData: boolean,
    isLoyalty: boolean,
    isPromotionalMail: boolean,
    isPoll: boolean,
    isPromotionalGames: boolean,
    phone: string,
    name: string,
    surname: string,
    patronymic: string,
    // gender: boolean,
    birthDate: any,
    // email: string,
    // address: string,
    cardNumber?:string,

  ) {
    const formattedValue = moment(birthDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
    return api.post('/v1/auth/check-application-data', {
      card_number: cardNumber?.length === 19 ? cardNumber.substr(12) : cardNumber,
      code,
      password,
      is_loyalty: isLoyalty,
      is_processing_personal_data: isProcessingPersonalData,
      is_promotional_mail: isPromotionalMail,
      is_poll: isPoll,
      is_promotional_games: isPromotionalGames,
      anketa: phone ? {
        phone,
        name,
        surname,
        patronymic,
        // pol: +gender,
        birthday: formattedValue,
        //   email,
      //  locality: address,
      } : undefined,
    })
  },
}
